import * as React from 'react'

const ScanFeedToggle = ({ color = '#4151E6', size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="6" width="18" height="10" rx="2" fill={color} />
    <path d="M10 9L15 11L10 13V9Z" fill="white" />
    <rect x="3" y="19" width="18" height="1.5" rx="0.75" fill={color} />
  </svg>
)

export default ScanFeedToggle
